<div id="layout" class="theme-cyan">

  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <div class="main-body">
      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Analytics Dashboard</h5>
                  </div>
                  <small class="text-truncate text-muted">Welcome to Postman</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">

            </div>

          </div>

        </div>
      </div>

      <!-- Body -->
      <div class="body-page d-flex py-xl-3 py-5">
        <div class="container">
          <div class="row g-3 mb-3">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card p-3 px-4">
                <div>Total Income</div>
                <div class="py-4 m-0 text-center h2">$6,258</div>
                <div class="d-flex">
                  <small class="text-muted">This year</small>
                  <div class="ms-auto">22%</div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card p-3 px-4">
                <div>Total Expense</div>
                <div class="py-4 m-0 text-center h2">$2,258</div>
                <div class="d-flex">
                  <small class="text-muted">This year</small>
                  <div class="ms-auto">17%</div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card p-3 px-4">
                <div>Number of Meetings</div>
                <div class="py-4 m-0 text-center h2">58</div>
                <div class="d-flex">
                  <small class="text-muted">This year</small>
                  <div class="ms-auto">34%</div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card p-3 px-4">
                <div>Number of Events</div>
                <div class="py-4 m-0 text-center h2">225</div>
                <div class="d-flex">
                  <small class="text-muted">This year</small>
                  <div class="ms-auto">19%</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-3 mb-3 row-deck">
            <div class="col-xl-6 col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h6 class="card-title">Sales Analytics</h6>
                </div>
                <app-column-line-chart></app-column-line-chart>
                <!-- <div id="apex-SalesAnalytics"></div> -->
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="card">
                <div class="card-body text-center">
                  <h6 class="card-title mb-4">Tickets</h6>
                  <app-basicradar-chart></app-basicradar-chart>
                  <div class="border-bottom py-3">
                    <span class="text-muted">Total Tickets</span>
                    <h6 class="mb-0">$3400.00</h6>
                  </div>
                  <div class="pt-3">
                    <span class="text-muted">Sold Tickets</span>
                    <h6 class="mb-0">$7300.00</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="card">
                <div class="card-body text-center">
                  <h6 class="card-title mb-4">Seats</h6>
                  <app-basicradar-chart></app-basicradar-chart>
                  <div class="border-bottom py-3">
                    <span class="text-muted">Total Seats</span>
                    <h6 class="mb-0">$3700.00</h6>
                  </div>
                  <div class="pt-3">
                    <span class="text-muted">Sold Seats</span>
                    <h6 class="mb-0">$9200.00</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12">
              <div class="card">
                <div class="card-header bg-transparent">
                  <h6 class="card-title mb-0">Recent Followers</h6>
                </div>
                <div class="card-body">
                  <form>
                    <div class="input-group mb-4">
                      <input type="text" class="form-control" placeholder="Search...">
                    </div>
                  </form>

                  <ul class="right_chat list-unstyled">
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar1.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Michelle Green</p>
                          <small class="text-truncate text-muted">Designer, Blogger</small>
                        </div>
                      </a>
                    </li>
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar2.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Folisise Chosielie</p>
                          <small class="text-truncate">Java Developer</small>
                        </div>
                      </a>
                    </li>
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar5.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Terry Carter</p>
                          <small class="text-truncate">Designer, Blogger</small>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar4.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Michelle Schultz</p>
                          <small class="text-truncate">Writter, Mag Editor</small>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12">
              <div class="card">
                <div class="card-header bg-transparent">
                  <h6 class="card-title mb-0">Users Overview</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 border-end">
                      <small>New Users</small>
                      <h4 class="fw-bold">2,025</h4>
                    </div>
                    <div class="col-6">
                      <small>Return Visitors</small>
                      <h4 class="fw-bold">1,254</h4>
                    </div>
                  </div>
                  <hr>
                  <div class="mb-4">
                    <label class="d-block">New Users <span class="float-end">77%</span></label>
                    <div class="progress" style="height: 2px;">
                      <div class="progress-bar bg-success" role="progressbar" aria-valuenow="77" aria-valuemin="0"
                        aria-valuemax="100" style="width: 77%;"></div>
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="d-block">Return Visitors <span class="float-end">50%</span></label>
                    <div class="progress" style="height: 2px;">
                      <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                        aria-valuemax="100" style="width: 50%;"></div>
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="d-block">Engagement <span class="float-end">23%</span></label>
                    <div class="progress" style="height: 2px;">
                      <div class="progress-bar progbgress-info" role="progressbar" aria-valuenow="23" aria-valuemin="0"
                        aria-valuemax="100" style="width: 23%;"></div>
                    </div>
                  </div>
                  <small class="font-12">The total number of Page Impressions within the date range<a href="">View
                      more</a></small>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12">
              <div class="card">
                <div class="card-header bg-transparent">
                  <h6 class="card-title mb-0">Top Countries</h6>
                </div>
                <table class="table table-hover mb-0">
                  <tbody>
                    <tr>
                      <td>
                        USA
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 78%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$6425</span></td>
                    </tr>
                    <tr>
                      <td>
                        Poland
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 62%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$5582</span></td>
                    </tr>
                    <tr>
                      <td>
                        Germany
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 48%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$4587</span></td>
                    </tr>
                    <tr>
                      <td>
                        Russia
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 35%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$2520</span></td>
                    </tr>
                    <tr>
                      <td>
                        Australia
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 30%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$1899</span></td>
                    </tr>
                    <tr>
                      <td>
                        Great Britain
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 22%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$1056</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End chat body -->
    </div>

  </div>
  <!-- Main Body: Content -->
</div>
